import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import SelectLineItems from '../../containers/SelectLineItems'

const SelectInvoiceServiceLineItems = ({
    i18n,
    defaultServiceLineItems = [],
    initialData,
    loading,
    onFetchInitialData,
    onSelectServiceLineItemsChange = () => {},
    orderId,
    vatIncluded = false
}) => {
    const vatIndicator = i18n.t(vatIncluded ? 'inquiries:vatIncluded' : 'inquiries:vatExcluded')

    const columns = [{
        title: i18n.t('inquiries:detail'),
        dataIndex: 'name',
        editable: true
    }, {
        title: i18n.t('inquiries:quantity'),
        dataIndex: 'quantity',
        editable: true
    }, {
        title: i18n.t('inquiries:unit'),
        dataIndex: 'unit',
        editable: true
    }, {
        title: `${i18n.t('inquiries:unitPrice')} (${vatIndicator})`,
        dataIndex: 'single_price',
        editable: true
    }, {
        title: i18n.t('inquiries:emptyLineBelow'),
        dataIndex: 'empty_line_below',
        editable: true
    }]

    return (
        <SelectLineItems
            columns={columns}
            dataSource={initialData}
            loading={loading}
            onChange={onSelectServiceLineItemsChange}
            onFetch={onFetchInitialData}
            orderId={orderId}
            value={defaultServiceLineItems}
        />
    )
}

SelectInvoiceServiceLineItems.propTypes = {
    defaultServiceLineItems: PropTypes.array,
    initialData: PropTypes.array,
    loading: PropTypes.bool,
    onFetchInitialData: PropTypes.func,
    onSelectServiceLineItemsChange: PropTypes.func,
    orderId: PropTypes.string.isRequired,
    vatIncluded: PropTypes.bool
}

export default withTranslation(['inquiries'])(SelectInvoiceServiceLineItems)
